import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    setPassword as setPasswordAction,
    resetPassword as resetPasswordAction,
} from '../../actions/auth';

import SetPasswordScreen from './SetPasswordScreen';

const _mapStateToProps = (state) => ({
    locale: state.authentication.locale,
});

const _mapDispatchToProps = {
    handleSetPassword: setPasswordAction,
    handleResetPassword: resetPasswordAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SetPasswordScreen),
);
